import {get} from 'lodash';
import gql from 'graphql-tag';
import {useQuery} from '@apollo/react-hooks';
import {fragments as propertyCardFragments} from '../../components/PropertyCarousel/PropertyCard/PropertyCard';

import {
    CARDS_MIN_LIMIT,
    DESKTOP_CARDS_MAX_LIMIT,
    MOBILE_CARDS_MAX_LIMIT
} from './constants';
import filterNonDisplayableListings from './utils/filterNonDisplayableListings';

const previouslyViewedSearchQuery = gql`
    query($request: SearchResultRequest!) {
        previouslyViewedSearch(request: $request) {
            listings {
                ...PropertyCardListing
            }
        }
    }
    ${propertyCardFragments.Listing}
`;

export const useFetchRecentlyViewedListings = (
    searchParams,
    isMobile,
    showMabCarousels = true
) => {
    const pageSize = isMobile
        ? MOBILE_CARDS_MAX_LIMIT
        : DESKTOP_CARDS_MAX_LIMIT;
    const {data, loading} = useQuery(previouslyViewedSearchQuery, {
        skip: !showMabCarousels,
        errorPolicy: 'ignore', // empty/errored hits will be filtered out by filterNonDisplayableListings
        variables: {
            request: {
                ...searchParams,
                paging: {
                    page: 1,
                    pageSize
                }
            }
        }
    });

    const listings = get(data, ['previouslyViewedSearch', 'listings'], []);
    const previouslyViewedListings = filterNonDisplayableListings(listings);

    if (previouslyViewedListings.length < CARDS_MIN_LIMIT) {
        return {
            previouslyViewedListings: [],
            previouslyViewedListingsLoading: loading
        };
    }

    return {previouslyViewedListings, previouslyViewedListingsLoading: loading};
};
